import * as dialogs from "@client/features/dialogs";

import {EntryJourney, ExercisesJourney, OnboardingJourney, SceneModal} from "./base";
import type * as exercises from "./exercises";
import type * as onboarding from "./onboarding";

export const useEntryDialog = () =>
    dialogs.useDialog({
        Content: EntryJourney,
        modal: SceneModal,
    });

export const useOnboardingDialog = () =>
    dialogs.useDialog<onboarding.Output, onboarding.Input>({
        Content: OnboardingJourney,
        modal: SceneModal,
    });

export const useExercisesDialog = () =>
    dialogs.useDialog<exercises.Output, exercises.Input>({
        Content: ExercisesJourney,
        modal: SceneModal,
    });
